import { Navigate } from 'react-router-dom';
import { hasPermission, PERMISSIONS } from './permissions';
import { useAdminAuth } from './useAdminAuth';

export function AdminOnlyRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAdminAuth();

  if (!hasPermission(user, PERMISSIONS.agentsView)) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
}
